{
  "familyId": "MET-SCHAAL-OPP",
  "questions": [
    {
      "id": "MET-SCHAAL-OPP-001",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de echte oppervlakte bij schaal 1:100. Hij zegt: \"1 cm² op de kaart = 100 cm² in het echt.\" Wat is zijn fout?",
      "context": null,
      "options": ["Hij vergeet de schaalfactor te kwadrateren: het moet 100² = 10.000 cm² zijn", "Hij moet door 100 delen in plaats van vermenigvuldigen", "Hij moet met 1000 vermenigvuldigen", "Er zit geen fout in zijn berekening"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 100,
            "mapLength": 1,
            "realLength": 1,
            "unit": "m",
            "label": "Schaal 1 : 100 (lengte)"
          }
        }
      ],
      "conceptId": "scale_area_error_analysis",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-richting-omgedraaid", "label": "Denkt dat je moet delen i.p.v. vermenigvuldigen", "optionIndex": 1 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Verwart ×1000 met ×100² = ×10.000", "optionIndex": 2 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat ×100 correct is — vergeet te kwadrateren", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling vergeet te kwadrateren. Bij lengte is het ×100, maar bij oppervlakte moet je de schaalfactor kwadrateren: 100² = 10.000. Dit komt doordat oppervlakte twee dimensies heeft (lengte × breedte), dus je vermenigvuldigt twee keer met 100. De juiste berekening: 1 cm² × 10.000 = 10.000 cm² in het echt.",
        "solutionSteps": [
          "Analyseer de bewering: de leerling zegt 1 cm² = 100 cm²",
          "Herken de fout: bij oppervlakte moet je de schaalfactor kwadrateren",
          "Bereken correct: 100² = 10.000, dus 1 cm² = 10.000 cm²",
          "Verklaring: oppervlakte = lengte × breedte, dus 100 × 100 = 10.000"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! Bij oppervlakte kwadrateer je de schaalfactor: 100² = 10.000. De leerling vergeet dit en gebruikt alleen ×100.",
          "1": "Je dacht waarschijnlijk dat je moet delen. Maar van kaart naar echt ga je naar grotere maten, dus je vermenigvuldigt. Bij oppervlakte: ×100² = ×10.000.",
          "2": "Je dacht waarschijnlijk dat het ×1000 is. Maar bij schaal 1:100 kwadrateer je 100: 100² = 10.000, niet 1000. Onthoud: oppervlakte = schaalfactor².",
          "3": "Er zit wél een fout in: 1 cm² ≠ 100 cm². Bij oppervlakte kwadrateer je: 1 cm² = 100² cm² = 10.000 cm². De leerling verwart lengte-omrekening met oppervlakte-omrekening."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-002",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de echte oppervlakte van een kamer (4 cm² op plattegrond, schaal 1:50). Hij schrijft: \"4 × 50 = 200 cm².\" Zijn klasgenoot zegt: \"Je mist een stap.\" Welke stap mist de leerling?",
      "context": null,
      "options": ["Hij moet eerst de wortel van 4 nemen", "Hij moet door 50 delen in plaats van vermenigvuldigen", "Hij moet de schaalfactor kwadrateren: 4 × 50² = 4 × 2.500 = 10.000 cm²", "Hij moet met 500 vermenigvuldigen"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 50,
            "mapLength": 2,
            "realLength": 1,
            "unit": "m",
            "label": "Schaal 1 : 50 (lengte)"
          }
        }
      ],
      "conceptId": "scale_area_error_context",
      "variantIndex": 2,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.66,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat je de wortel moet nemen i.p.v. kwadrateren", "optionIndex": 0 },
          { "id": "met.schaal-richting-omgedraaid", "label": "Denkt dat je moet delen i.p.v. vermenigvuldigen", "optionIndex": 1 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Verwart ×500 met ×50² = ×2.500", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling vermenigvuldigt met 50, maar bij oppervlakte moet je de schaalfactor kwadrateren. De juiste berekening: 4 × 50² = 4 × 2.500 = 10.000 cm². Dit komt doordat oppervlakte twee dimensies heeft: de lengte wordt ×50 én de breedte wordt ×50, dus samen ×2.500.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 4 × 50 = 200",
          "Herken de fout: bij oppervlakte kwadrateer je de schaalfactor",
          "Bereken correct: 4 × 50² = 4 × 2.500 = 10.000 cm²",
          "Verklaring: oppervlakte heeft twee dimensies, dus 50 × 50 = 2.500"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de wortel van de oppervlakte moet nemen. Maar je kwadratéért de schaalfactor, niet de oppervlakte. Onthoud: oppervlakte × schaalfactor².",
          "1": "Je dacht waarschijnlijk dat je moet delen. Maar van plattegrond naar echt ga je naar grotere maten, dus je vermenigvuldigt. Bij oppervlakte: ×50² = ×2.500.",
          "2": "Goed geanalyseerd! De leerling vergeet te kwadrateren. Bij oppervlakte: 4 × 50² = 4 × 2.500 = 10.000 cm², niet 4 × 50 = 200 cm².",
          "3": "Je dacht waarschijnlijk dat het ×500 is. Maar bij schaal 1:50 kwadrateer je 50: 50² = 2.500, niet 500. Onthoud: oppervlakte = schaalfactor²."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-003",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de echte oppervlakte van een tuin (3 cm × 5 cm op plattegrond, schaal 1:200). Hij schrijft: \"3 × 5 = 15 cm². Dan 15 × 200 = 3.000 cm² = 0,3 m².\" Wat doet de leerling fout?",
      "context": null,
      "options": ["Hij rekent cm² verkeerd om naar m²", "Hij vermenigvuldigt met 200 in plaats van met 200² = 40.000", "Hij moet de lengtes eerst apart omrekenen", "Er zitten twee fouten in zijn berekening"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 5, "height": 3, "showGrid": true, "unit": "cm", "label": "Plattegrond 1:200" }
        }
      ],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 200,
            "mapLength": 3,
            "realLength": 6,
            "unit": "m",
            "label": "Schaal 1 : 200 (lengte)"
          }
        }
      ],
      "conceptId": "scale_area_error_direct",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-eenheid-omrekenen", "label": "Denkt dat de fout in cm²→m² zit, maar die omrekening klopt", "optionIndex": 0 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat apart omrekenen een fout is — het is een alternatieve methode", "optionIndex": 2 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat er twee fouten zijn, maar alleen ×200 i.p.v. ×200² is fout", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling maakt de klassieke fout: hij vermenigvuldigt de oppervlakte met de schaalfactor (×200) in plaats van met het kwadraat van de schaalfactor (×200² = ×40.000). Dit komt doordat oppervlakte twee dimensies heeft: zowel de lengte als de breedte worden ×200. Dus de oppervlakte wordt ×200 × ×200 = ×40.000. De juiste berekening: 15 cm² × 40.000 = 600.000 cm² = 60 m². Je kunt controleren via de lengtes: 3 cm × 200 = 6 m, 5 cm × 200 = 10 m, 6 × 10 = 60 m². De leerling krijgt 0,3 m², het juiste antwoord is 60 m² — een factor 200 verschil.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 15 × 200 = 3.000 cm²",
          "Identificeer de fout: bij oppervlakte moet je ×200² gebruiken, niet ×200",
          "Verklaar waarom: oppervlakte = lengte × breedte, dus beide dimensies ×200 → ×40.000",
          "Bereken correct: 15 × 40.000 = 600.000 cm² = 60 m²",
          "Controleer via lengtes: 3 cm × 200 = 6 m, 5 cm × 200 = 10 m, 6 × 10 = 60 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de fout in de omrekening naar m² zit. De leerling rekent 3.000 cm² = 0,3 m² — dat klopt (3.000 ÷ 10.000 = 0,3). De echte fout zit eerder: hij vermenigvuldigt met 200 i.p.v. 200².",
          "1": "Goed geanalyseerd! De leerling vergeet te kwadrateren. Bij oppervlakte: ×200² = ×40.000, niet ×200. Het juiste antwoord is 15 × 40.000 = 600.000 cm² = 60 m².",
          "2": "De lengtes apart omrekenen is een geldige methode (6 m × 10 m = 60 m²), maar het is niet de fout. De fout is dat de leerling ×200 gebruikt i.p.v. ×200². Beide methodes geven 60 m² als je ze correct toepast.",
          "3": "Er zit maar één kernfout in: ×200 i.p.v. ×200². De omrekening cm² → m² (÷10.000) past de leerling correct toe op zijn (foutieve) tussenresultaat. De oplossing is: kwadrateer de schaalfactor bij oppervlakte."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-004",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een woonkamer van 24 m² op een plattegrond met schaal 1:50. Een leerling berekent: \"24 ÷ 50 = 0,48 cm².\" Zijn klasgenoot zegt: \"Je vergeet twee stappen.\" Welke twee stappen mist de leerling?",
      "context": null,
      "options": ["Hij hoeft alleen door 50² te delen, de eenheden kloppen al", "Hij moet vermenigvuldigen in plaats van delen, en omrekenen naar cm²", "Hij moet door 50² delen en dan met 100 vermenigvuldigen", "Hij moet eerst omrekenen naar cm² (24 m² = 240.000 cm²) én delen door 50² in plaats van 50"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 50,
            "mapLength": 9.8,
            "realLength": 4.9,
            "unit": "m",
            "label": "Schaal 1 : 50"
          }
        }
      ],
      "conceptId": "scale_area_reverse_error",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.65,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-eenheid-omrekenen", "label": "Vergeet dat m² eerst naar cm² moet", "optionIndex": 0 },
          { "id": "met.schaal-richting-omgedraaid", "label": "Denkt dat je moet vermenigvuldigen i.p.v. delen (echt→tekening)", "optionIndex": 1 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat ×100 na het delen de oplossing is", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling maakt twee fouten tegelijk. Fout 1: hij deelt door 50 in plaats van door 50² = 2.500 (bij oppervlakte kwadrateer je de schaalfactor). Fout 2: hij rekent niet om naar dezelfde eenheid — 24 m² ≠ 24 cm². De juiste aanpak: eerst 24 m² = 240.000 cm², dan 240.000 ÷ 2.500 = 96 cm². De leerling krijgt 0,48 cm², het juiste antwoord is 96 cm² — een enorm verschil door twee gemiste stappen.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 24 ÷ 50 = 0,48",
          "Identificeer fout 1: de leerling deelt door 50 i.p.v. 50² = 2.500",
          "Identificeer fout 2: de leerling behandelt 24 m² alsof het 24 cm² is",
          "Corrigeer stap 1: 24 m² = 24 × 10.000 = 240.000 cm²",
          "Corrigeer stap 2: 240.000 ÷ 2.500 = 96 cm²",
          "Controleer: 96 × 2.500 = 240.000 cm² = 24 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Alleen door 50² delen is niet genoeg — de leerling moet ook de eenheden omrekenen. 24 m² ÷ 2.500 = 0,0096 m², maar de plattegrond is in cm². Eerst: 24 m² = 240.000 cm², dan: 240.000 ÷ 2.500 = 96 cm².",
          "1": "Je dacht waarschijnlijk dat de leerling moet vermenigvuldigen. Maar van echt naar plattegrond ga je naar kleinere maten, dus je deelt. De twee fouten zijn: verkeerde eenheid (m² vs. cm²) en niet kwadrateren (÷50 i.p.v. ÷2.500).",
          "2": "Je dacht waarschijnlijk dat je na het delen nog met 100 moet vermenigvuldigen. Maar als je eerst correct omrekent naar cm² (240.000) en dan deelt door 50² (2.500), krijg je direct het antwoord in cm²: 96 cm².",
          "3": "Goed geanalyseerd! De leerling mist twee stappen: (1) omrekenen naar cm² (24 m² = 240.000 cm²) en (2) delen door 50² = 2.500 i.p.v. 50. Juist antwoord: 240.000 ÷ 2.500 = 96 cm²."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-005",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Twee leerlingen berekenen de echte oppervlakte van een park (2 cm × 4 cm op plattegrond, schaal 1:300). Leerling A: \"2 × 300 = 600 cm = 6 m, 4 × 300 = 1.200 cm = 12 m, 6 × 12 = 72 m².\" Leerling B: \"2 × 4 = 8 cm², 8 × 300² = 720.000 cm² = 72 m².\" Beoordeel beide methodes.",
      "context": null,
      "options": ["Alleen methode B is correct, A vergeet te kwadrateren", "Alleen methode A is correct, B maakt een rekenfout", "Beide methodes zijn correct en geven hetzelfde antwoord (72 m²)", "Beide methodes zijn fout, het antwoord is 2.400 m²"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 4, "height": 2, "showGrid": true, "unit": "cm", "label": "Plattegrond 1:300" }
        }
      ],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 300,
            "mapLength": 2,
            "realLength": 6,
            "unit": "m",
            "label": "Schaal 1 : 300"
          }
        }
      ],
      "conceptId": "scale_area_compare_methods",
      "variantIndex": 5,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.67,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat methode A vergeet te kwadrateren — maar A rekent lengtes apart om", "optionIndex": 0 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat methode B een fout bevat — maar 8 × 90.000 = 720.000 cm² = 72 m² klopt", "optionIndex": 1 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Vergeet zelf te kwadrateren: 8 × 300 = 2.400, niet 8 × 300² = 720.000", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Beide methodes zijn wiskundig correct en geven hetzelfde antwoord. Methode A (lengtes apart omrekenen): 6 m × 12 m = 72 m². Methode B (oppervlakte × schaalfactor²): 8 × 90.000 = 720.000 cm² = 72 m². Dit is geen toeval — het is wiskundig equivalent: (2×300) × (4×300) = 2×4 × 300² = 8 × 90.000. Het verschil is de aanpak, niet het resultaat. Methode A is vaak makkelijker te begrijpen, methode B is sneller bij complexe vormen.",
        "solutionSteps": [
          "Controleer methode A: 2 × 300 = 600 cm = 6 m, 4 × 300 = 1.200 cm = 12 m, 6 × 12 = 72 m² ✓",
          "Controleer methode B: 2 × 4 = 8 cm², 300² = 90.000, 8 × 90.000 = 720.000 cm² = 72 m² ✓",
          "Vergelijk: beide geven 72 m² — wiskundig equivalent",
          "Verklaar waarom: (a×300) × (b×300) = a×b × 300² — de volgorde van vermenigvuldigen maakt niet uit",
          "Beoordeel: methode A is inzichtelijker, methode B is efficiënter"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat methode A vergeet te kwadrateren. Maar methode A hoeft niet te kwadrateren — hij rekent elke lengte apart om (×300) en vermenigvuldigt daarna. Dat is wiskundig hetzelfde als ×300².",
          "1": "Je dacht waarschijnlijk dat methode B een fout bevat. Maar 8 × 300² = 8 × 90.000 = 720.000 cm² = 72 m² is correct. Methode B kwadratéért de schaalfactor, wat wiskundig hetzelfde is als beide lengtes apart omrekenen.",
          "2": "Goed geanalyseerd! Beide methodes zijn correct. A rekent lengtes apart om (6 × 12 = 72 m²), B gebruikt schaalfactor² (8 × 90.000 = 720.000 cm² = 72 m²). Wiskundig equivalent.",
          "3": "Beide methodes geven 72 m², niet 2.400 m². 2.400 zou je krijgen als je 8 × 300 doet (zonder te kwadrateren) — dat is de veelgemaakte fout die beide leerlingen juist vermijden."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-006",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent bij schaal 1:500: \"2 cm² op de plattegrond = 2 × 500 = 1.000 cm². Dat is 1.000 ÷ 10.000 = 0,1 m².\" Corrigeer de berekening. Wat is de echte oppervlakte?",
      "context": null,
      "options": ["0,1 m², de berekening klopt", "50 m², want je moet met 500² = 250.000 vermenigvuldigen", "10 m², want je moet met 5.000 vermenigvuldigen", "100 m², want je moet met 500.000 vermenigvuldigen"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 500,
            "mapLength": 1,
            "realLength": 5,
            "unit": "m",
            "label": "Schaal 1 : 500 (lengte)"
          }
        }
      ],
      "conceptId": "scale_area_large_factor_error",
      "variantIndex": 6,
      "citoDifficulty": 0.53,
      "citoDiscrimination": 0.66,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Denkt dat ×500 correct is — vergeet te kwadrateren", "optionIndex": 0 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Verwart ×5.000 met ×500² = ×250.000", "optionIndex": 2 },
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Verwart ×500.000 met ×500² = ×250.000", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "De leerling maakt de klassieke fout: hij vermenigvuldigt met 500 in plaats van met 500² = 250.000. Bij oppervlakte heeft elke dimensie de schaalfactor, dus je vermenigvuldigt twee keer: 500 × 500 = 250.000. De juiste berekening: 2 cm² × 250.000 = 500.000 cm². Omrekenen: 500.000 ÷ 10.000 = 50 m². De leerling krijgt 0,1 m², het juiste antwoord is 50 m² — een factor 500 verschil, precies de ontbrekende schaalfactor.",
        "solutionSteps": [
          "Analyseer de berekening: de leerling doet 2 × 500 = 1.000 cm²",
          "Identificeer de fout: bij oppervlakte kwadrateer je de schaalfactor → 500² = 250.000",
          "Verklaar waarom: oppervlakte = lengte × breedte, dus ×500 × ×500 = ×250.000",
          "Bereken correct: 2 × 250.000 = 500.000 cm² = 50 m²",
          "Controleer: het verschil (0,1 m² vs. 50 m²) is precies factor 500 — de ontbrekende schaalfactor ✓"
        ],
        "distractorExplanations": {
          "0": "De berekening klopt niet. De leerling vermenigvuldigt met 500, maar bij oppervlakte moet je met 500² = 250.000 vermenigvuldigen. Het juiste antwoord is 50 m², niet 0,1 m².",
          "1": "Goed gecorrigeerd! De leerling vergeet te kwadrateren: 2 × 500² = 2 × 250.000 = 500.000 cm² = 50 m². Het verschil met zijn antwoord (0,1 m²) is precies factor 500.",
          "2": "Je dacht waarschijnlijk dat het ×5.000 is. Maar bij schaal 1:500 kwadrateer je 500: 500² = 250.000, niet 5.000. Onthoud: oppervlakte = schaalfactor², dus 500 × 500 = 250.000.",
          "3": "Je dacht waarschijnlijk dat het ×500.000 is. Maar 500² = 250.000, niet 500.000. 2 × 250.000 = 500.000 cm² = 50 m², niet 100 m². Onthoud: kwadrateren = ×zichzelf, niet ×1.000."
        }
      }
    },
    {
      "id": "MET-SCHAAL-OPP-007",
      "familyId": "MET-SCHAAL-OPP",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "schaal",
      "subSkill": "schaal_oppervlakte",
      "questionType": "step_solver",
      "question": "Op een plattegrond met schaal 1 : 200 is een kamer 6 cm × 4 cm. Wat is de werkelijke oppervlakte in m²? Werk stap voor stap.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "prompt": "Stap 1: Bereken de oppervlakte op de plattegrond in cm².", "correctAnswer": "24", "hint": "Vermenigvuldig de twee zijden: 6 × 4.", "explanation": "6 × 4 = 24 cm² op de plattegrond." },
          { "prompt": "Stap 2: Bij schaal 1:200 — met welke factor vermenigvuldig je de oppervlakte?", "correctAnswer": "40000", "hint": "Bij oppervlakte kwadrateer je de schaalfactor: 200 × 200.", "explanation": "200² = 40.000. Onthoud: schaalfactor voor oppervlakte = (lineaire factor)²." },
          { "prompt": "Stap 3: Bereken de werkelijke oppervlakte in cm² (24 × 40.000), en zet om naar m².", "correctAnswer": "96", "hint": "24 × 40.000 = 960.000 cm². Deel daarna door 10.000 (cm² → m²).", "explanation": "24 × 40.000 = 960.000 cm² = 96 m²." }
        ],
        "finalAnswer": "96"
      },
      "stimulusAids": [{ "type": "ratio", "data": { "headers": ["Lengte", "Oppervlakte"], "rows": [["×200", "×40.000"]], "label": "Schaalfactor lengte vs. oppervlakte" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Drie stappen bij schaal-oppervlakte", "content": "1) Plattegrond-opp: l × b. 2) Schaalfactor kwadrateren: n² . 3) Vermenigvuldigen en eenheid omrekenen (÷10.000 voor cm² → m²).", "icon": "lightbulb" } }],
      "conceptId": "schaal_opp_multistep",
      "variantIndex": 7,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.schaal-opp-niet-gekwadrateerd", "label": "Schaal niet gekwadrateerd" }
        ]
      },
      "feedback": {
        "explanationText": "Drie stappen: (1) opp plattegrond = 6 × 4 = 24 cm². (2) Bij schaal 1:200 vermenigvuldig je oppervlakte met 200² = 40.000 (niet met 200!). (3) 24 × 40.000 = 960.000 cm² = 96 m². De grote val is stap 2 vergeten: dan krijg je 4,8 m² (factor 20 te klein). Onthoud: lengte ×200, oppervlakte ×40.000.",
        "solutionSteps": [
          "Stap 1: 6 × 4 = 24 cm² op plattegrond",
          "Stap 2: 200² = 40.000 (schaalfactor voor oppervlakte)",
          "Stap 3: 24 × 40.000 = 960.000 cm² = 96 m²"
        ]
      }
    }
  ]
}